// Hero Slider (Hotfix 6.4)
// - section setting controls autoplay seconds, hover stops, offscreen stops
// - prev/next state is exposed for the desktop peek carousel
// - キーボード ← → 対応、prefers-reduced-motion 対応
(function () {
  'use strict';
  var slider = document.querySelector('[data-hero-slider]');
  if (!slider) return;

  var slides = slider.querySelectorAll('.hero-slide');
  var dots = slider.querySelectorAll('.hero-dot');
  var prev = slider.querySelector('[data-hero-prev]');
  var next = slider.querySelector('[data-hero-next]');
  if (slides.length < 2) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currentIndex = 0;
  var timer = null;
  var frame = null;
  var idle = window.requestIdleCallback || function (callback) { return window.setTimeout(callback, 1); };
  var intervalAttr = parseInt(slider.getAttribute('data-hero-interval-ms'), 10);
  var interval = Number.isFinite(intervalAttr) ? Math.max(3000, intervalAttr) : 6000;
  var autoplayEnabled = slider.getAttribute('data-hero-autoplay') !== 'false';
  var isVisible = false;
  var isHovering = false;

  function getNeighborIndexes(index) {
    var prevIndex = index - 1;
    var nextIndex = index + 1;
    if (prevIndex < 0) prevIndex = slides.length - 1;
    if (nextIndex >= slides.length) nextIndex = 0;
    return { prev: prevIndex, next: nextIndex };
  }

  function warmImages(slide, isPriority) {
    if (!slide) return;
    var images = slide.querySelectorAll('img');
    images.forEach(function (img) {
      img.loading = 'eager';
      if (isPriority && 'fetchPriority' in img) img.fetchPriority = 'high';
      idle(function () {
        if (img.decode) img.decode().catch(function () {});
      });
    });
  }

  function warmVisibleSlides() {
    var neighbors = getNeighborIndexes(currentIndex);
    warmImages(slides[currentIndex], true);
    warmImages(slides[neighbors.prev], false);
    warmImages(slides[neighbors.next], false);
  }

  function syncSlides() {
    var neighbors = getNeighborIndexes(currentIndex);

    slides.forEach(function (slide, index) {
      var isActive = index === currentIndex;
      var isPrev = index === neighbors.prev;
      var isNext = index === neighbors.next;
      slide.classList.toggle('is-active', isActive);
      slide.classList.toggle('is-prev', isPrev);
      slide.classList.toggle('is-next', isNext);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if ('inert' in slide) slide.inert = !isActive;
    });
  }

  function syncDots() {
    dots.forEach(function (dot, index) {
      var isActive = index === currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function normalizeIndex(idx) {
    if (idx < 0) return slides.length - 1;
    if (idx >= slides.length) return 0;
    return idx;
  }

  function applyIndex(idx) {
    currentIndex = normalizeIndex(idx);
    syncSlides();
    syncDots();
    warmVisibleSlides();
  }

  function goTo(idx) {
    idx = normalizeIndex(idx);
    if (idx === currentIndex) return;
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      frame = null;
      applyIndex(idx);
    });
  }
  function nextSlide() { goTo(currentIndex + 1); }
  function prevSlide() { goTo(currentIndex - 1); }

  function startAuto() {
    stopAuto();
    if (!autoplayEnabled || reduced || !isVisible || isHovering) return;
    timer = window.setTimeout(function () {
      nextSlide();
      startAuto();
    }, interval);
  }
  function stopAuto() {
    if (timer) { window.clearTimeout(timer); timer = null; }
  }

  if (next) next.addEventListener('click', function () { nextSlide(); startAuto(); });
  if (prev) prev.addEventListener('click', function () { prevSlide(); startAuto(); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); startAuto(); });
  });

  slider.addEventListener('pointerenter', function () { isHovering = true; stopAuto(); });
  slider.addEventListener('pointerleave', function () { isHovering = false; startAuto(); });

  slider.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { prevSlide(); startAuto(); }
    if (e.key === 'ArrowRight') { nextSlide(); startAuto(); }
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isVisible = entry.isIntersecting;
        if (isVisible) startAuto(); else stopAuto();
      });
    }, { threshold: 0.2 });
    io.observe(slider);
  } else {
    isVisible = true;
    startAuto();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAuto();
    else startAuto();
  });

  syncSlides();
  syncDots();
  warmVisibleSlides();
  slider.classList.add('is-ready');
})();
